import $ from 'jquery';

// Expose jQuery $-shorthand, since the tracking container relies on it
window.$ = $;

initDataLayer();
injectTagCommanderContainer();
initFormJobSearchTrackingDataAttributesUpdate();
initFormJobSearchStoreTrackingDataAttributesUpdate();

function initDataLayer() {
  let siteHierarchy = $('#site-hierarchy');

  window.tc_vars = {
    env_template: pageDataLayer.siteIdentifier,
    env_work: pageDataLayer.envWork, // variable, Integ System='preprod'; live System='prod'
    env_country: pageDataLayer.language.toUpperCase(),
    env_device: getCookie('deviceType'),
    env_language: pageDataLayer.language,
    page_cat_id: pageDataLayer.pageId, // UID of page from pageDataLayer
    page_cat1: siteHierarchy.find('span:nth-child(1)').text(), // use #site-hierarchy
    page_cat2: siteHierarchy.find('span:nth-child(2)').text(), // use #site-hierarchy
    page_cat3: siteHierarchy.find('span:nth-child(3)').text(), // use #site-hierarchy
    page_cat4: siteHierarchy.find('span:nth-child(4)').text(), // use #site-hierarchy
    page_cat5: siteHierarchy.find('span:nth-child(5)').text(), // use #site-hierarchy
    page_name: siteHierarchy.find('span:last-child').text(), // use #site-hierarchy
  };
}

// Load TagCommander Container: The Data Layer needs to be filled with information before the TagCommander Container file is loaded
function injectTagCommanderContainer() {
  if (typeof window.pageDataLayer.tagCommanderContainer !== 'undefined' && window.pageDataLayer.tagCommanderContainer !== '') {
    $.getScript(window.pageDataLayer.tagCommanderContainer).done(updateElementTrackingDataAttributes);
  }
}

function updateElementTrackingDataAttributes() {
  $('[data-ef-tcetype="element"][data-ef-tcedata]').each((index, element) => {
    const $element = $(element);
    const tcedata = JSON.parse($element.attr('data-ef-tcedata'));

    if('kategorie' in tcedata && tcedata.kategorie === '__js__page_category_path') {
      // Update value for "kategorie" in "data-ef-tcedata" Attribute
      tcedata.kategorie = window.tC.internalvars.page_category_path;
      $element.attr('data-ef-tcedata', JSON.stringify(tcedata));
    }
  });
}

// update "data-ef-tcedata" tracking attribute for searchForm
function initFormJobSearchTrackingDataAttributesUpdate() {
  const $jobSearchForm = $('form.ef-form-job-search__form');
  const $searchBtn = $jobSearchForm.find('button[data-ef-tcetype="Jobfinder"][data-ef-tcedata="__js__update_on_fields_change"]');

  if($searchBtn.length > 0) {
    updateFormJobSearchTrackingDataAttributes($jobSearchForm, $searchBtn);  // update on page load
    $jobSearchForm.find('input, select').on('change', function () {
      updateFormJobSearchTrackingDataAttributes($jobSearchForm, $searchBtn);  // update on change the field values
    });
  }
}

function updateFormJobSearchTrackingDataAttributes(jobSearchForm, searchBtn) {
  // value for data-ef-tcedata
  const jobSearchTcedata = {
    'Land': jobSearchForm.find('#STsearchfield_LAND option').filter(':selected').val(),
    'Aufgabengebiet': jobSearchForm.find('#STsearchfield_AUFG_GEBIET option').filter(':selected').val(),
    'Postleitzahl': jobSearchForm.find('#UMKREIS_PLZ').val(),
    'Umkreis': jobSearchForm.find('#STsearchfield_UMKREIS_KM option').filter(':selected').val(),
  }
  searchBtn.attr('data-ef-tcedata', JSON.stringify(jobSearchTcedata));
}

// update "data-ef-tcedata" tracking attribute for job search store form
function initFormJobSearchStoreTrackingDataAttributesUpdate() {
  const $jobSearchStoreForm = $('form.ef-form-job-search-store');
  const $searchBtn = $jobSearchStoreForm.find('button[data-ef-tcetype="PLZ_Suche"][data-ef-tcedata="__js__update_on_fields_change"]');

  if($searchBtn.length > 0) {
    updateFormJobSearchStoreTrackingDataAttributes($jobSearchStoreForm, $searchBtn);  // update on page load
    $jobSearchStoreForm.find('input, select').on('change', function () {
      updateFormJobSearchStoreTrackingDataAttributes($jobSearchStoreForm, $searchBtn); // update on change the field values
    });
  }
}

function updateFormJobSearchStoreTrackingDataAttributes(jobSearchStoreForm, searchBtn) {
  // value for data-ef-tcedata
  const jobSearchStoreTcedata = {
    'PLZ_Jobsuche': jobSearchStoreForm.find('#UMKREIS_PLZ').val(),
  }
  searchBtn.attr('data-ef-tcedata', JSON.stringify(jobSearchStoreTcedata))
}

function getCookie(name) {
  const cookies = document.cookie;
  const value = '; ' + cookies;
  let parts = value.split('; ' + name + '=');

  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
}
